// extracted by mini-css-extract-plugin
module.exports = {"account":"Account_account__AE6Sz","terminalCode":"Account_terminalCode__1SQQZ","userIcon":"Account_userIcon__2ygxs"};